import TechnicalInformation from 'containers/Slices/TechnicalInformation';

export const seriesTechnicalTab = (block, type, index) => {
  switch (type) {
    case 'information_tab':
      return <TechnicalInformation block={block} key={`${type}-${index}`} />;
    default:
      return '';
  }
};
